module.exports = __webpack_public_path__ + "img/kn.1b368ddb.svg";